import { veros } from '../../../apis/homeowner/veros';
import { WebApiRequest, HTTP_GET, HTTP_PUT } from "../../../tools/webservice";

export const checkForPreviewResults = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: veros.checkForPreviewResults(controlIdNumber),
  successCallback,
  mountedRef,
});
export const submittalIsRequired = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: veros.submittalIsRequired(controlIdNumber),
  successCallback,
  mountedRef,
});

export const submitResultViewCurrent = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: veros.submitResultViewCurrent(controlIdNumber),
  successCallback,
  mountedRef,
});

export const submitInitiate = (controlIdNumber, successCallback, mountedRef, errorCallback) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: veros.submitInitiate(controlIdNumber),
  successCallback,
  mountedRef,
  errorCallback,
});
